import { MaterialUICore, tokens } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

const useStyles = makeStyles(() => ({
  header: {
    backgroundColor: tokens.color.secondary.light,
    padding: 0,
    margin: 0,
    display: 'flex',
    maxWidth: '100%',
    position: 'fixed',
    zIndex: 2,
    top: '50px',
    boxShadow: '0px 4px 16px rgba(0, 99, 207, 0.08)',
  },
  patient: {
    border: `${tokens.border.width.hairline} solid ${tokens.color.neutral[50]};`,
    width: '320px',
    height: '112px',
    display: 'flex',
    padding: `${tokens.spacing.sm} ${tokens.spacing.base} ${tokens.spacing.sm} ${tokens.spacing.md}`,
  },
  avatar: {
    width: '48px',
    height: '48px',
  },
  name: {
    fontWeight: tokens.font.weight.bold,
    fontSize: tokens.font.size.xs,
    lineHeight: tokens.line.height.md,
  },
  info: {
    fontWeight: tokens.font.weight.regular,
    fontSize: tokens.font.size.xxs,
    fontStyle: 'normal',
    lineHeight: tokens.line.height.md,
  },
  card: {
    width: '238px',
    height: '88px',
    padding: tokens.spacing.sm,
    marginLeft: tokens.spacing.sm,
    backgroundColor: tokens.color.neutral[0],
    border: `${tokens.border.width.hairline} solid ${tokens.color.neutral[50]}`,
    '&:hover': {
      boxShadow: '0px 4px 8px rgba(0, 99, 207, 0.08)',
      cursor: 'pointer',
    },
  },
  containerCard: {
    padding: `${tokens.spacing.xs} 0 ${tokens.spacing.xs} ${tokens.spacing.md}`,
    display: 'flex',
  },
  section: {
    fontWeight: tokens.font.weight.medium,
    fontSize: tokens.font.size.xxxs,
  },
  observation: {
    fontWeight: tokens.font.weight.regular,
    fontSize: tokens.font.size.xxxs,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '200px',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
